import React, { useEffect, useState } from "react";
import { Footer } from "../../Components/Footer";
import Header from "../../Components/Header";

export const Layout = ({ children, loading, setSelectedCategory }) => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="d-flex flex-column min-vh-100">
      <Header setSelectedCategory={setSelectedCategory} />
      <main
        className="flex-grow-1 w-100"
        style={{ paddingBottom: isDesktop ? "2rem" : "120px" }}
      >
        {loading ? <div>loading</div> : children}
      </main>
      <Footer />
    </div>
  );
};
